export default __webpack_public_path__ + "static/media/logo-light.64b95882.png";